import React, { ReactNode, createContext } from 'react';

import { createServices } from './serviceFactory';
import { Services } from './serviceTypes';

// Create the context with null as default - will be provided by ServiceProvider
// eslint-disable-next-line react-refresh/only-export-components
export const ServiceContext = createContext<Services | null>(null);

// Default services using the factory
const defaultServices: Services = createServices();

interface ServiceProviderProps {
  children: ReactNode;
  services?: Partial<Services>;
}

export const ServiceProvider: React.FC<ServiceProviderProps> = ({ children, services = {} }) => {
  const mergedServices = { ...defaultServices, ...services };

  return <ServiceContext.Provider value={mergedServices}>{children}</ServiceContext.Provider>;
};
